// Production servers
const ProdApiServers = [
  "api-mumbai.polyguard.ai",
  "api-oregon.polyguard.ai",
  "api-sao-paulo.polyguard.ai",
  "api-ireland.polyguard.ai",
  "api-virginia.polyguard.ai",
  "api-cape-town.polyguard.ai",
  "api-sydney.polyguard.ai",
  "api-global.polyguard.ai",
];

const DevApiServers = [
  "api.actual.video",
  "local-api.actual.video",
  "serge.local-api.actual.video",
  "api-josh.local.actual.video",
  "khadem.local-api.actual.video",
];

// Get servers based on environment
const getApiServers = () => {
  if (process.env.NODE_ENV === 'production') {
    return ProdApiServers;
  }
  return [...ProdApiServers, ...DevApiServers];
};

  // Proof types (hardcoded for now)
  const PROOF_TYPES = [
    { type: 'pg_attestation_key_id', label: 'Device Verification' },
    { type: 'name', label: 'Full Name' },
    { type: 'pg_presence', label: 'Physical Presence', disabled: false },
    { type: 'pg_region', label: 'Location (State & Country)' },
    { type: 'phone_number', label: 'Phone Number' },
    { type: 'pg_age', label: 'Age', disabled: false },
    { type: 'pg_photo_verification_url', label: 'Photo Verification' },
    // { type: 'Employer', label: 'Employer', disabled: true },
  ];

export { getApiServers, PROOF_TYPES };